<template>
  <div class="row px-2">
    <div class="col-lg-6">
      <div class="card p-5 px-6">
        <BlockUI
          class="h-200px position-relative"
          :loading="blockRights"
        />
        <div
          v-if="companyQuato"
          class="row d-flex"
        >
          <div class="d-flex flex-column justify-content-between col-lg-6">
            <div class="d-flex flex-column">
              <span class="card-label fw-bolder fs-3">{{ translate("dashboars_audit_rights") }}</span>
              <span class="text-muted fw-bold fs-7">{{ translate("dashboard_remaining_rights_subscriptions") }}</span>
            </div>

            <div class="d-flex align-items-end mt-5">
              <a
                class="btn btn-sm btn-primary btn-active-primary my-1 me-2"
                data-bs-toggle="modal"
                data-bs-target="#subscription-modal"
                >{{ translate("dashboard_view_detail") }}</a
              >
            </div>
          </div>

          <div
            class="d-flex align-items-start justify-content-end col-lg-6"
            :style="`font-size:${quotaFontSize};text-size-adjust: 0.5px; 125px; line-height: 120px`"
          >
            <span class="text-gray-900 quato">{{ companyQuato.CompanyTotalRemainin }}</span>
            <!-- <span class="text-gray-500 fs-6">({{ translate("dashboard_remaiming") }})</span> -->

            <span class="fw-semibold text-dark mx-3 pt-1 text-gray-900 quato">/</span>

            <span class="text-gray-900 quato">{{ companyQuato.CompanyTotalQuota }} </span>
            <!-- <span class="text-gray-500 fs-6">({{ translate("analysis_total") }})</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <SubscriptionModal />
  <div class="row">
    <div class="col-lg-6 p-5">
      <audit-plan-card />
    </div>
    <div class="col-lg-6 p-5">
      <div class="card p-5">
        <h3 class="card-title d-flex align-items-start flex-column mb-12">
          <span class="card-label fw-bolder fs-3 mb-1">{{ translate("dashboard_pending_approval") }}</span>
          <span class="text-muted fw-bold fs-7">
            {{ translate("dashboard_pending_description") }}
          </span>
        </h3>
        <div class="separator mb-2"></div>
        <div
          class="h-350px d-flex justify-content-center align-items-center position-relative"
          v-if="totalItemsApproval == 0"
        >
          <BlockUI :loading="blockApprove" />
          <span class="fs-6 text-gray-600"> {{ translate("dasboard_approval_confirm") }}</span>
        </div>
        <div
          v-else
          class="h-310px overflow-auto position-relative"
        >
          <BlockUI
            :loading="blockApprove"
            class="h-300px"
          />
          <div class="h-300px">
            <div
              class="mb-2 d-flex align-items-center p-2"
              v-for="approval in approvaLAuditList"
              :key="approval"
            >
              <span class="bullet bullet-vertical h-40px bg-success"></span>

              <div class="flex-grow-1 mx-5">
                <a class="text-gray-800 fw-bolder fs-6">{{ approval.LocationName }}</a
                ><span class="text-muted fw-bold d-block">{{ approval.AuditDateTime }}</span>
              </div>
              <router-link
                :to="{
                  path: `/audit/audit-details/${approval.Id}`,
                }"
              >
                <a
                  class="btn btn-sm btn-light btn-light-success"
                  style="pointer-event: none"
                >
                  {{ translate("send_approve") }}
                </a>
              </router-link>
            </div>
          </div>
        </div>
        <div
          v-if="totalItemsApproval > 0"
          class="mt-3"
        >
          <Pagination
            @onPage="onPageApprove"
            :TotalData="totalItemsApproval"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6 p-5">
      <div class="card p-5 h-450px">
        <h3 class="card-title align-items-start flex-column mb-8">
          <span class="card-label fw-bolder fs-3 mb-2">{{ translate("dashboard_customers_audit") }}</span>
          <div class="text-muted fw-bold fs-7">
            {{ translate("dashboard_customers_audit_number") }}
          </div>
        </h3>

        <div class="separator mb-3"></div>
        <div
          class="h-350px d-flex justify-content-center align-items-center position-relative"
          v-if="totalItemsApproval == 0"
        >
          <BlockUI :loading="blockApprove" />
          <span class="fs-6 text-gray-600"> {{ translate("dashboard_card_customer_confirm") }}</span>
        </div>
        <div
          v-else
          class="h-350px p-0 position-relative"
        >
          <BlockUI :loading="blockCustomer" />
          <div class="h-300px overflow-auto">
            <div
              class="d-flex flex-stack mb-4 px-2"
              v-for="customer in customerList"
              :key="customer"
            >
              <div class="d-flex align-items-center me-2">
                <div class="symbol symbol-45px me-3">
                  <div class="symbol-label">
                    <img
                      src="media/icons/duotune/general/company.svg"
                      alt=""
                      class="h-50"
                    />
                  </div>
                </div>
                <div>
                  <span class="fs-6 text-gray-800 fw-bolder">{{ customer.CustomerName }}</span>
                  <div class="fs-7 text-muted fw-bold mt-1">
                    {{ customer.TotalLocationCount }}
                    {{ translate("dashboard_location") }}
                  </div>
                </div>
              </div>
              <div class="badge badge-light fw-bold py-4 px-3">
                {{ customer.TotalAuditCount }}
                {{ translate("dashboard_audit") }}
              </div>
            </div>
          </div>
        </div>

        <div>
          <Pagination
            v-if="totalItemsApproval != 0"
            @onPage="onPageCustomer"
            :TotalData="TotalItemsCustomer"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-6 p-5">
      <div class="card p-5 h-450px">
        <h3 class="card-title align-items-start flex-column">
          <span
            v-if="weekGraphic"
            class="card-label fw-bolder fs-3"
            >{{ translate("dashboard_week_apexchart_title") }}</span
          >
          <span
            v-if="monthGraphic"
            class="card-label fw-bolder fs-3"
            >{{ translate("dashboard_month_apexchart_title") }}</span
          >
          <span
            v-if="yearGraphic"
            class="card-label fw-bolder fs-3"
            >{{ translate("dashboard_year_apexchart_title") }}</span
          >
        </h3>
        <nav>
          <div
            class="nav nav-tabs mb-5"
            id="nav-tab"
            role="tablist"
          >
            <button
              class="nav-link active"
              id="nav-home-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-home1"
              type="button"
              role="tab"
              aria-controls="nav-home"
              aria-selected="true"
              @click="getApexchartDay('weekAgain')"
            >
              {{ translate("dashboard_week_apexchart") }}
            </button>
            <button
              class="nav-link"
              id="nav-profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-profile1"
              type="button"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false"
              @click="getApexchartDay('month')"
            >
              {{ translate("dashboard_month_apexchart") }}
            </button>
            <button
              class="nav-link"
              id="nav-contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-contact1"
              type="button"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false"
              @click="getApexchartDay('year')"
            >
              {{ translate("dashboard_year_apexchart") }}
            </button>
          </div>
        </nav>
        <div
          class="tab-content"
          id="nav-tabContent"
        >
          <div
            class="tab-pane fade show active position-relative p-2"
            id="nav-home1"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <BlockUI
              :loading="blockGraph"
              class="h-325px"
            />
            <apexchart
              height="350"
              type="bar"
              :options="options"
              :series="series"
            >
            </apexchart>
          </div>
          <div
            class="tab-pane fade position-relative"
            id="nav-profile1"
            role="tabpanel"
            aria-labelledby="nav-profile-tab"
          >
            <BlockUI
              :loading="blockGraph"
              class="h-325px"
            />
            <apexchart
              height="350"
              type="bar"
              :options="optionsMonth"
              :series="seriesMonth"
            >
            </apexchart>
          </div>
          <div
            class="tab-pane fade position-relative"
            id="nav-contact1"
            role="tabpanel"
            aria-labelledby="nav-contact-tab"
          >
            <BlockUI
              :loading="blockGraph"
              class="h-325px"
            />
            <apexchart
              height="350"
              type="bar"
              :options="optionsYear"
              :series="seriesYear"
            >
            </apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "vuex";
import auditPlanCard from "@/components/Dashboard/AuditPlanCard.vue";
import { ref, watch, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useI18n } from "vue-i18n";
import SubscriptionModal from "@/components/Dashboard/SubscriptionModal.vue";
import { userGuard } from "@/store/utils/userGourad";

const { t, te, locale } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};
const store = useStore();
const weekApexchart = ref([]);
const monthApexchart = ref([]);
const yearApexchart = ref([]);
const weekApexchartValue = ref([]);
const monthApexchartValue = ref([]);
const yearApexchartValue = ref([]);
const blockApprove = ref(true);
const blockCustomer = ref(true);
const blockGraph = ref(true);
const blockRights = ref(true);

const weekGraphic = ref(true);
const monthGraphic = ref(false);
const yearGraphic = ref(false);

const clickMonth = ref(false);
const clickYear = ref(false);

const lazyParamsCustomer = ref([]);
const lazyParamsApprove = ref([]);

const quotaFontSize = ref("120px");
lazyParamsCustomer.value = {
  page: 1,
  pageSize: 10,
};
lazyParamsApprove.value = {
  page: 1,
  pageSize: 10,
};

const getApexchartDay = (payload) => {
  store.dispatch("DashboardModule/GET_APEXCHART_PERIOD", payload).then((response) => {
    if (payload == "week") {
      let WeekList = response;
      WeekList.forEach((element) => {
        weekApexchart.value.push(element.date);
        weekApexchartValue.value.push(element.value);
      });
    } else if (payload == "month") {
      weekGraphic.value = false;
      monthGraphic.value = true;
      yearGraphic.value = false;

      if (clickMonth.value == false) {
        let MonthList = response;
        MonthList.forEach((element) => {
          optionsMonth.xaxis.categories.push(element.date);
          seriesMonth[0].data.push(element.value);
          clickMonth.value = true;
        });
      }
    } else if (payload == "year") {
      weekGraphic.value = false;
      monthGraphic.value = false;
      yearGraphic.value = true;
      if (clickYear.value == false) {
        let YearList = response;
        YearList.forEach((element) => {
          optionsYear.xaxis.categories.push(element.date);
          seriesYear[0].data.push(element.value);
          clickYear.value = true;
        });
      }
    } else if (payload == "weekAgain") {
      weekGraphic.value = true;
      monthGraphic.value = false;
      yearGraphic.value = false;
    }
    if (response) {
      blockGraph.value = false;
    }
  });
};
const onPageCustomer = (e) => {
  lazyParamsCustomer.value.page = e.step.value;
  lazyParamsCustomer.value.pageSize = e.pageSize.value;
  getCustomers(lazyParamsCustomer.value.page, lazyParamsApprove.value.pageSize);
};
const onPageApprove = (e) => {
  lazyParamsApprove.value.page = e.step.value;
  lazyParamsApprove.value.pageSize = e.pageSize.value;
  getApprovalAudits(lazyParamsApprove.value.page, lazyParamsApprove.value.pageSize);
};
const options = {
  chart: {
    id: "vuechart-example",
    height: 300,
    type: "area",
  },
  xaxis: {
    categories: weekApexchart.value,
  },
  yaxis: {
    title: {
      text: translate("dashboard_audit_number"),
    },
    labels: {
      formatter: function (value) {
        return parseInt(value);
      },
    },
  },
  fill: {
    type: "gradient",
    gradient: {
      gradientToColors: ["#3464C3"],
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0.5,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.8,
      stops: [0, 100],
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 5,
    },
  },
  colors: ["#214cc5"],
  noData: {
    text: translate("analysis_no_audit"),
    align: "center",
    verticalAlign: "middle",
    offsetX: 0,
    offsetY: 0,
    style: {
      color: undefined,
      fontSize: "14px",
      fontFamily: undefined,
    },
  },
};
const series = [
  {
    name: translate("dashboard_audit_number"),
    data: weekApexchartValue.value,
  },
];
const optionsMonth = {
  chart: {
    id: "vuechart-example",
    height: 300,
  },
  plotOptions: {
    bar: {
      borderRadius: 5,
    },
  },
  colors: ["#214cc5"],
  fill: {
    type: "gradient",
    gradient: {
      gradientToColors: ["#3464C3"],
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0.5,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.8,
      stops: [0, 100],
    },
  },
  xaxis: {
    categories: monthApexchart.value,
  },
  yaxis: {
    title: {
      text: translate("dashboard_audit_number"),
    },
    labels: {
      formatter: function (value) {
        return Math.floor(value);
      },
    },
  },

  noData: {
    text: translate("analysis_no_audit"),
    align: "center",
    verticalAlign: "middle",
    offsetX: 0,
    offsetY: 0,
    style: {
      color: undefined,
      fontSize: "14px",
      fontFamily: undefined,
    },
  },
};
const seriesMonth = [
  {
    name: translate("dashboard_audit_number"),
    data: monthApexchartValue.value,
  },
];
const optionsYear = {
  chart: {
    id: "vuechart-example",
    height: 200,
  },
  xaxis: {
    categories: yearApexchart.value,
  },
  yaxis: {
    title: {
      text: translate("dashboard_audit_number"),
    },
  },
  plotOptions: {
    bar: {
      borderRadius: 5,
    },
  },
  colors: ["#214cc5"],
  fill: {
    type: "gradient",
    gradient: {
      gradientToColors: ["#3464C3"],
      shade: "dark",
      type: "vertical",
      shadeIntensity: 0.5,
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.8,
      stops: [0, 100],
    },
  },
  noData: {
    text: translate("analysis_no_audit"),
    align: "center",
    verticalAlign: "middle",
    offsetX: 0,
    offsetY: 0,
    style: {
      color: undefined,
      fontSize: "14px",
      fontFamily: undefined,
    },
  },
};
const seriesYear = [
  {
    name: translate("dashboard_audit_number"),
    data: yearApexchartValue.value,
  },
];
const approvaLAuditList = ref([]);
const totalItemsApproval = ref(0);
const getApprovalAudits = (pageIndex, pageSize) => {
  let obj = {
    pageIndex: pageIndex,
    pageSize: pageSize,
  };

  store
    .dispatch("DashboardModule/GET_APPROVAL_AUDITS", obj)
    .then((response) => {
      approvaLAuditList.value = response.ListItems;
      totalItemsApproval.value = response.TotalItemsCount;
    })
    .finally(() => {
      blockApprove.value = false;
    });
};
const customerList = ref([]);
const TotalItemsCustomer = ref(0);

const getCustomers = (pageIndex, pageSize) => {
  let objCustomers = {
    pageIndex: pageIndex,
    pageSize: pageSize,
  };
  store
    .dispatch("DashboardModule/GET_STATICS_BY_CUSTOMER", objCustomers)
    .then((response) => {
      customerList.value = response.ListItems;
      TotalItemsCustomer.value = response.TotalItemsCount;
    })
    .finally(() => {
      blockCustomer.value = false;
    });
};

const getData = () => {
  const obj = {
    pageIndex: 1,
    pageSize: 10,
  };
  store.dispatch("DashboardModule/GET_COMPANY_QUATO", obj).then((response) => {
    if (response) {
      companyQuato.value = response;
      let quotaLength = response.CompanyTotalRemainin.toString().length + response.CompanyTotalQuota.toString().length;

      if (quotaLength <= 3) {
        quotaFontSize.value = "120px";
      } else if (3 < quotaLength && quotaLength < 6) {
        quotaFontSize.value = "100px";
      } else {
        quotaFontSize.value = "80px";
      }
    }
    blockRights.value = false;
  });
};

getApexchartDay("week");
getCustomers(1, 10);
getApprovalAudits(1, 10);
getData();
watch(locale, () => {
  setCurrentPageBreadcrumbs(translate("Menu_Dashboard"));
});

let companyQuato = ref(0);

onMounted(() => {
  setCurrentPageBreadcrumbs(translate("Menu_Dashboard"));
});
</script>
